import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DatePicker, Loadable, EntitySelector } from "components/support";
import Moment from "moment";

class Filter extends Component {
  handleChange = ({ startDate, endDate }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    onChange(options);
  };

  handleField = ({ product }) => {
    const { onFilter } = this.props;
    const value = {};

    value.product = product;

    return onFilter(value);
  };

  render() {
    const {
      loading,
      filters,
      productSearchOptions,
      onSelectProduct
    } = this.props;

    const { dateFrom, dateTo, product } = filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable
          loading={loading}
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          }}
          shadow
        >
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={4}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
              />
            </Col>
            <Col xs={12} lg={4}>
              <EntitySelector
                label="Produto"
                title="Selecionar Produto"
                value={product.name}
                searchOptions={productSearchOptions}
                onSelect={product => onSelectProduct(product)}
                parser={product => ({ key: product.uuid, title: product.name })}
                nullSelection={{ uuid: "", name: "" }}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/filter/index.jsx